import * as Sentry from '@sentry/browser';
import { type ApiClientError, ApiClientErrorResponse } from '~/ApiClient';
import type { AppError } from '~/ErrorHandler';

export default function logError(error: AppError | Error | { message?: string } | ApiClientErrorResponse) {
	if (error instanceof ApiClientErrorResponse) {
		logApiError(error);
		return;
	}
	if (error instanceof Error) {
		Sentry.captureException(error);
		return;
	}

	// @ts-expect-error error is unknown
	const jsError = new Error(error.message);
	jsError.name = error instanceof Object ? error.constructor.name : 'UnknownError';
	Sentry.captureException(jsError);
}

export function normalizeErrorSentryExtra(errors: ApiClientError[]) {
	return errors.map((error) => ({
		...Object.entries(error).reduce(
			(normalized: { [key: string]: string | { [key: string]: any } }, [key, value]) => ({
				...normalized,
				[key]: ['string', 'number'].indexOf(typeof value) > -1 ? value : JSON.stringify(value),
			}),
			{}
		),
	}));
}

function logApiError(errorResponse: ApiClientErrorResponse) {
	const url = errorResponse.request ? errorResponse.request.url : null;
	const fingerprint: any[] = [
		'{{ default }}',
		url,
		errorResponse.statusCode,
		...errorResponse.unhandledErrors.map((error) => error.code),
	].filter((print) => print !== null);

	Sentry.withScope((scope) => {
		scope.setFingerprint(fingerprint as string[]);
		scope.setExtra('request:url', url);
		scope.setExtra('request:options', errorResponse.request ? errorResponse.request.options : null);
		scope.setExtra('response:errors', normalizeErrorSentryExtra(errorResponse.unhandledErrors));
		Sentry.captureException(errorResponse.asError());
	});
}
